import styled from 'styled-components';
import { Button, lightenDarkenColor } from '../shared/utils/styles';

export const ButtonContainer = styled.div`
  & button {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 7px 12px;
    height: 50px;
    border: 1px solid gray;
    :disabled {
      cursor: not-allowed;
      background-color: #e7e7e7;
      color: #666;
    }
    & i {
      padding-right: 5px;
      font-size: 1.2em;
    }
  }
`;

export const ConnectButton = styled(Button)`
  font-weight: normal;
  background-color: #009E0F;
  color: #ffffff;
  &:hover {
    background-color: ${lightenDarkenColor('#009E0F', 20)};
    color: #ffffff;
  }
`;

export const DisconnectButton = styled(Button)`
  font-weight: normal;
  background-color: #DB2828;
  color: #ffffff;
  &:hover {
    background-color: ${lightenDarkenColor('#DB2828', 50)};
    color: #ffffff;
  }
`;

export const TopBarButtonContainer = styled.div`
  & button {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 4px 8px;
    height: 30px;
    border: 1px solid gray;
    :disabled {
      cursor: not-allowed;
      background-color: #e7e7e7;
      color: #666;
    }
    & i {
      padding-right: 5px;
      font-size: 1.2em;
    }
  }
`;
